import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// THE ACTIVE TAB, KEPT IN THE URL (?tab=<name>), so a tabbed screen can be linked to, reloaded and sent to someone
// on the tab it was on. Unknown or missing values fall back to `fallback` (a tab handed over in navigation state, then
// the first tab). Other query parameters (from=, filters) are kept. The URL is REPLACED, not pushed: clicking between
// tabs must not stack history entries that Back has to walk through before it leaves the screen.
//
//   const [tab, setTab] = useUrlTab(['general', 'company'], location.state?.tab);
export default function useUrlTab(tabs, fallback) {
    const [searchParams, setSearchParams] = useSearchParams();
    const fromUrl = searchParams.get('tab');
    const tab = tabs.includes(fromUrl) ? fromUrl : (tabs.includes(fallback) ? fallback : tabs[0]);

    const setTab = useCallback((next) => {
        setSearchParams(prev => {
            const p = new URLSearchParams(prev);
            p.set('tab', next);
            return p;
        }, { replace: true });
    }, [setSearchParams]);

    return [tab, setTab];
}
